export enum VotingFarmStatus {
  Added = 'added',
  Declined = 'declined',
  BlackList = 'black_list',
  Active = 'active',
  Preparing = 'preparing',
}

export type VotingItemDto = {
  id: number;
  pairSymbol: string;
  dexscreenerChainId: string;
  dexName: string;
  startDate: string;
  closingDate: string;
  tvlUsd: string;
  marketCap: string;
  volume24h: string;
  token0: string;
  token1: string;
  votes: string;
  isVoted: boolean;
  status: VotingFarmStatus;
};

export type VotingDto = {
  items: VotingItemDto[];
  count: number;
};

export type FarmStatisticsItemDto = {
  dexName: string;
  dexscreenerChainId: string;
  addedFarms: string;
  activeProposal: string;
  farmCanceled: string;
  votes: string;
};

export type FarmsStatisticsDto = {
  items: FarmStatisticsItemDto[];
  count: number;
};

export type FarmDataDto = {
  dexscreenerChainId: string;
  pairSymbol: string;
  dexName: string;
  address: string;
  tvlUsd: string;
  volume24h: string;
  marketCap: string;
  startDate: string;
  closingDate: string;
  token0: string;
  token1: string;
  farmId: null | number;
  id: number;
  createdAt: string;
  updatedAt: string;
  status: VotingFarmStatus;
  isVoted: false;
};
